import { LANGUAGE } from '@/types';
import af from './af';
import afZA from './af-ZA';
import arAE from './ar-AE';
import beBY from './be-BY';
import bgBG from './bg-BG';
import bn from './bn';
import bnBD from './bn-BD';
import bnIN from './bn-IN';
import bsBA from './bs-BA';
import caES from './ca-ES';
import csCZ from './cs-CZ';
import daDK from './da-DK';
import deDE from './de-DE';
import elGR from './el-GR';
import enGB from './en-GB';
import enSG from './en-SG';
import enUS from './en-US';
import enZA from './en-ZA';
import esES from './es-ES';
import etET from './et-ET';
import euES from './eu-ES';
import fiFI from './fi-FI';
import frFR from './fr-FR';
import gu from './gu';
import guIN from './gu-IN';
import heIL from './he-IL';
import hiIN from './hi-IN';
import hrHR from './hr-HR';
import huHU from './hu-HU';
import hyAM from './hy-AM';
import idID from './id-ID';
import isIS from './is-IS';
import itIT from './it-IT';
import jaJP from './ja-JP';
import kaGE from './ka-GE';
import kk from './kk';
import kkKZ from './kk-KZ';
import koKO from './ko-KO';
import ltLT from './lt-LT';
import lvLV from './lv-LV';
import meME from './me-ME';
import mkMK from './mk-MK';
import mnMN from './mn-MN';
import ms from './ms';
import msMY from './ms-MY';
import msSG from './ms-SG';
import mtMT from './mt-MT';
import noNO from './nb-NO';
import nlNL from './nl-NL';
import paIN from './pa-IN';
import paPK from './pa-PK';
import plPL from './pl-PL';
import ptBR from './pt-BR';
import ptPT from './pt-PT';
import roRO from './ro-RO';
import ruRU from './ru-RU';
import skSK from './sk-SK';
import sqAL from './sq-AL';
import srRS from './sr-RS';
import svSE from './sv-SE';
import sw from './sw';
import swKE from './sw-KE';
import taIN from './ta-IN';
import taSG from './ta-SG';
import te from './te';
import teIN from './te-IN';
import th from './th';
import thTH from './th-TH';
import tlPH from './tl-PH';
import tnZA from './tn-ZA';
import trTR from './tr-TR';
import ukUA from './uk-UA';
import urIN from './ur-IN';
import urPK from './ur-PK';
import uz from './uz';
import vi from './vi';
import viVN from './vi-VN';
import xhZA from './xh-ZA';
import zhCN from './zh-CN';
import zhHK from './zh-HK';
import zhSG from './zh-SG';
import zhTW from './zh-TW';
import zu from './zu';
import zuZA from './zu-ZA';
export const lngs = {
    [LANGUAGE.AFRIKAANS]: af,
    [LANGUAGE.AFRIKAANS_ZA]: afZA,
    [LANGUAGE.ALBANIAN]: sqAL,
    [LANGUAGE.ARABIC]: arAE,
    [LANGUAGE.ARMENIAN]: hyAM,
    [LANGUAGE.BASQUE]: euES,
    [LANGUAGE.BELARUSIAN]: beBY,
    [LANGUAGE.BENGALI]: bn,
    [LANGUAGE.BENGALI_BD]: bnBD,
    [LANGUAGE.BENGALI_IN]: bnIN,
    [LANGUAGE.BOSNIAN]: bsBA,
    [LANGUAGE.BULGARIAN]: bgBG,
    [LANGUAGE.CATALAN]: caES,
    [LANGUAGE.CHINESE]: zhCN,
    [LANGUAGE.CHINESE_HK]: zhHK,
    [LANGUAGE.CHINESE_SG]: zhSG,
    [LANGUAGE.CHINESE_TW]: zhTW,
    [LANGUAGE.CROATIAN]: hrHR,
    [LANGUAGE.CZECH]: csCZ,
    [LANGUAGE.DANISH]: daDK,
    [LANGUAGE.DUTCH]: nlNL,
    [LANGUAGE.ENGLISH_GB]: enGB,
    [LANGUAGE.ENGLISH_SG]: enSG,
    [LANGUAGE.ENGLISH_US]: enUS,
    [LANGUAGE.ENGLISH_ZA]: enZA,
    [LANGUAGE.ESTONIAN]: etET,
    [LANGUAGE.FINNISH]: fiFI,
    [LANGUAGE.FRENCH]: frFR,
    [LANGUAGE.GEORGIAN]: kaGE,
    [LANGUAGE.GERMAN]: deDE,
    [LANGUAGE.GREEK]: elGR,
    [LANGUAGE.GUJARATI]: gu,
    [LANGUAGE.GUJARATI_IN]: guIN,
    [LANGUAGE.HEBREW]: heIL,
    [LANGUAGE.HINDI]: hiIN,
    [LANGUAGE.HUNGARIAN]: huHU,
    [LANGUAGE.ICELANDIC]: isIS,
    [LANGUAGE.INDONESIAN]: idID,
    [LANGUAGE.ITALIAN]: itIT,
    [LANGUAGE.JAPANESE]: jaJP,
    [LANGUAGE.KAZAKH]: kk,
    [LANGUAGE.KAZAKH_KZ]: kkKZ,
    [LANGUAGE.KOREAN]: koKO,
    [LANGUAGE.LATIN]: srRS,
    [LANGUAGE.LATVIAN]: lvLV,
    [LANGUAGE.LITHUANIAN]: ltLT,
    [LANGUAGE.MACEDONIAN]: mkMK,
    [LANGUAGE.MALAY]: ms,
    [LANGUAGE.MALAY_MY]: msMY,
    [LANGUAGE.MALAY_SG]: msSG,
    [LANGUAGE.MALTESE]: mtMT,
    [LANGUAGE.MONGOLIAN]: mnMN,
    [LANGUAGE.MONTENEGRIN]: meME,
    [LANGUAGE.NORWEGIAN]: noNO,
    [LANGUAGE.PANJABI_IN]: paIN,
    [LANGUAGE.PANJABI_PK]: paPK,
    [LANGUAGE.POLISH]: plPL,
    [LANGUAGE.PORTUGUESE]: ptBR,
    [LANGUAGE.PORTUGUESE_PT]: ptPT,
    [LANGUAGE.ROMANIAN]: roRO,
    [LANGUAGE.RUSSIAN]: ruRU,
    [LANGUAGE.SLOVAK]: skSK,
    [LANGUAGE.SPANISH]: esES,
    [LANGUAGE.SWAHILI]: sw,
    [LANGUAGE.SWAHILI_KE]: swKE,
    [LANGUAGE.SWEDISH]: svSE,
    [LANGUAGE.TAGALOG]: tlPH,
    [LANGUAGE.TAMIL_IN]: taIN,
    [LANGUAGE.TAMIL_SG]: taSG,
    [LANGUAGE.TELUGU]: te,
    [LANGUAGE.TELUGU_IN]: teIN,
    [LANGUAGE.THAI]: th,
    [LANGUAGE.THAI_TH]: thTH,
    [LANGUAGE.TSWANA]: tnZA,
    [LANGUAGE.TURKISH]: trTR,
    [LANGUAGE.UKRAINIAN]: ukUA,
    [LANGUAGE.URDU_IN]: urIN,
    [LANGUAGE.URDU_PK]: urPK,
    [LANGUAGE.UZBEK]: uz,
    [LANGUAGE.VIETNAMESE]: vi,
    [LANGUAGE.VIETNAMESE_VN]: viVN,
    [LANGUAGE.XHOSA]: xhZA,
    [LANGUAGE.ZULU]: zu,
    [LANGUAGE.ZULU_ZA]: zuZA
};
export const resources = Object.entries(lngs).reduce((acc, [lng, resource]) => {
    acc[lng] = resource;
    if (lng.includes('-')) {
        const [languageFamily] = lng.split('-');
        if (!acc[languageFamily]) {
            acc[languageFamily] = resource;
        }
    }
    if (lng === LANGUAGE.ENGLISH_GB) {
        acc.en = resource;
    }
    return acc;
}, {});
